const INITIAL_STATE = {
    authorized: false,
    currentUser: null,
    loading: false,
    error: null
};

export const USER_ROLES = {
    ROLE_REPORT: "ROLE_REPORT"
};

export default function(state = INITIAL_STATE, action) {
    let error;
    switch(action.type) {

        case "LOGIN":
            return { ...state, authorized: false, currentUser: null, loading: true, error: null };
        case "LOGIN_SUCCESS":
            return { ...state, authorized: true, currentUser: action.payload, loading: false, error: null };
        case "LOGIN_FAILURE":
            error = action.payload || {message: action.payload.message};//2nd one is network or server down errors
            return { ...state, authorized: false, currentUser: null, loading: false, error: error };
        case "LOGOUT":
            return { ...state, authorized: false, currentUser: null, loading: false, error: null };

        case "FETCH_USER":
            return { ...state, loading: true, error: null };
        case "FETCH_USER_SUCCESS":
            return { ...state, authorized: true, currentUser: action.payload, loading: false, error: null };
        case "FETCH_USER_FAILURE":
            return { ...state, authorized: false, currentUser: null, loading: false, error: null };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/user.js